
import { inject, Injectable, DOCUMENT } from '@angular/core';
import { EnvironmentService } from '@libs/shared/common';

@Injectable({
  providedIn: 'root',
})
export class GtmService {
  private readonly document: Document = inject(DOCUMENT);
  private readonly env: EnvironmentService = inject(EnvironmentService);
  private initializedContainerId: string | undefined;

  private readonly scriptText: string = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','{CONTAINER_ID}');
  `;

  public initialize(id?: string): void {
    if (this.initializedContainerId) {
      return;
    }

    const containerId: string | undefined = id ?? this.env.app().gtmID;

    if (!containerId) {
      return;
    }

    this.initializedContainerId = containerId;

    const gtmElement: HTMLScriptElement = this.document.createElement('script');

    gtmElement.text = this.scriptText.replace('{CONTAINER_ID}', containerId);

    this.document.head.appendChild(gtmElement);
  }
}
